import { render, staticRenderFns } from "./CookieList.vue?vue&type=template&id=8d328f9c&scoped=true&lang=html&"
import script from "./CookieList.vue?vue&type=script&lang=js&"
export * from "./CookieList.vue?vue&type=script&lang=js&"
import style0 from "./CookieList.vue?vue&type=style&index=0&id=8d328f9c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d328f9c",
  null
  
)

export default component.exports